import React from "react"
import { Message } from "semantic-ui-react"

class TopMessage extends React.PureComponent {
  render() {
    const { ama } = this.props
    return (
      <Message>
        <ul>
          <li style={{ fontWeight: "bold" }}>AMA : {ama}</li>
          <li>
            Τα στοιχεία σας (Βαθμός, Ειδικότητα, Επώνυμο, Όνομα, Πατρώνυμο) δεν
            εμφανίζονται για λόγους ασφαλείας.
          </li>
          <li>
            Η ταυτότητά σας είναι γνωστή από το όνομα χρήστη με το οποίο
            συνδεθήκατε.
          </li>
          <li>
            Η εκτύπωση ή η αποθήκευση της παρούσας σελίδας θα είναι εφικτή με
            την οριστική υποβολή των στοιχείων.
          </li>
        </ul>
      </Message>
    )
  }
}

export default TopMessage
